import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notioceState: null,
    aboutState: 1,
    aboutShow: false,
    noticeShow: false,
  },
  mutations: {
    changeNotice(state, index) {
      state.notioceState = index;
    },
    changeAbout(state, index) {
      state.aboutState = index;
    },
    navSlideShow(state, type) {
      if (this.timer) clearTimeout(this.timer);
      switch (type) {
        case 1:
        case 2:
        case 4:
        case 0:
          state.noticeShow = false;
          state.aboutShow = false;
          break;
        case 5:
          if (state.noticeShow || state.solutionShow) {
            state.noticeShow = false;
            setTimeout(() => {
              state.aboutShow = true;
            }, 500);
          } else {
            state.aboutShow = true;
          }
          break;
        case 3:
          if (state.aboutShow || state.solutionShow) {
            state.aboutShow = false;
            setTimeout(() => {
              state.noticeShow = true;
            }, 500);
          } else {
            state.noticeShow = true;
          }
          break;
        default:
          return;
          break;
      }
    },
    navSlideHide(state) {
      this.timer = setTimeout(() => {
        state.aboutShow = false;
        state.noticeShow = false;
      }, 100);
    },
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js